import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
// import { ScopeService } from '../../../scope/scope.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService  } from './../../services/authentication.service';
import { BehaviorSubject, finalize, Subject, takeUntil } from 'rxjs';
import { DailyLogService} from './../daily-log.service';
// import { HttpBaseComponent } from './../../../../app/';
// import { PdfMakeService } from './../pdf-make.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { CommonService } from './../../services/common.service';

// This is needed to use the fonts
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
(pdfMake as any).vfs = (pdfFonts as any).pdfMake.vfs;

@Component({
  selector: 'control-daily-logs-pdf',
  templateUrl: './daily-logs-pdf.component.html',
  styleUrls: ['./daily-logs-pdf.component.scss']
})
export class DailyLogsPdfComponent  implements OnInit {
  @ViewChild('contentToConvert') contentToConvert: ElementRef | undefined;
  customer_name: string;
  customer_address: string;
  currentVerisonId: string;
  project_type: string;
  stage_type: string;
  date_created: string;
  org: string;
  org_name: string;
  org_email: string;
  org_phone: string;
  areaOfHouseArrayInScope: any[] = [];
  areaOfHouseArrayOutScope: any[] = [];
  tradeTypeArrayInScope: any[] = []
  tradeTypeArrayOutScope: any[] = []
  customer_add: string;
  project_id: string;
  stageId: string;
  versionId: string;
  orgId: string;
  apiPayload: any;
  tradePayload: any;
  ngUnsubscribe = new Subject();
  isLoaderActive: Boolean;
  business: string;
  logo: string;
  variationId: string | number;
  contractorId: string;
  dailyLogId: string;
  loadingSubject = new BehaviorSubject<boolean>(false);
  // Observables to subscribe, to get the subject's values
  public loading$ = this.loadingSubject.asObservable();
  photos = [];
  documents = [];
  videos = [];
  projectName = '';
  titleName = '';
  created_by: string = '';
  titleDescription: any;
  temperature: string;
  location: string;
  icon_url: string;
  humidity: number;
  wind_speed: number;
  feel_like_temp: number;
  weather_desc: string;
  icon: string;
  type:number;
  user_id: string;
  weatherDetails=[];
  isDownloadingPdf:boolean=false;
  isFranchisee:boolean=false;
  constructor( private dailyLogsService: DailyLogService, public router: Router, private route: ActivatedRoute,private commonService:CommonService) {
    // super();
    // this.projectId = this.route.snapshot.paramMap.get("projectId");
    this.stageId = this.route.snapshot.paramMap.get("stageId");
    this.versionId = this.route.snapshot.paramMap.get("versionId");
    this.currentVerisonId = this.route.snapshot.paramMap.get("vid");
    this.variationId = this.route.snapshot.paramMap.get("variationId");
    this.variationId = this.variationId ? this.variationId : "0";

    console.log(this.variationId, 'id')
    // this.orgId = this.authService.getUserInfoObject.orgId;

    this.business = this.commonService.isFranchisee?this.commonService.business:sessionStorage.getItem('Business');
    console.log(this.business);

    if (this.business === 'REFRESH') {
      this.logo = './../../../../assets/images/Refresh-logo-2.svg'
    }
    else if (this.business === 'ZONES') {
      this.logo = './../../../../assets/images/zones.svg'
    }
    // this.projectId = this.route.snapshot.paramMap.get('project_id');
    // this.contractorId = this.route.snapshot.paramMap.get('contractor_id');
    // this.dailyLogId = this.route.snapshot.paramMap.get('daily_log_id');
  }

  ngOnInit(): void {
    // this.generatePDF();
    let projectName = sessionStorage.getItem('projectName');
    // this.setBreadcrumb([
    //   { link: `/my-projects/project/${this.projectId}`, label: projectName },
    //   { link: `/my-projects/daily-logs/daily-logs-list/${this.projectId}/${this.contractorId}`, label: 'Daily Logs' },
    //   { link: '', label: 'Daily Log Details' }
    // ]);
    this.route.queryParams.subscribe((qParams:any) => {
      console.log(qParams);
      this.dailyLogId=qParams?.daily_log_id;
      this.type=qParams?.type;
      this.getDailyLogsOnID();
      this.user_id=qParams?.user_id;
      this.project_id=qParams?.project_id;
      this.isFranchisee=this.commonService.isFranchisee;
      // this.projectId = qParams?.id,
      //   this.contractorId = qParams?.contractorId
    })
  }

  // openSnackbar(message: string) {
  //   this.snackbarService.open(message);
  // }

  // generatePDF() {
  //   let commonPayload = {
  //     "version_id": this.versionId == "0" ? this.currentVerisonId : this.versionId,
  //     "stage_id": this.stageId,
  //     "deal_id": this.projectId,
  //     "org_id": this.orgId,
  //     "variation_id": this.variationId
  //   }
  //   let snackMessage = '';
  //   // Call api for Area of House
  //   this.generatePdfService.generatePDF({ ...commonPayload, "group_type": "AOH", }).subscribe((data) => {
  //     if (data.status === false) {
  //       snackMessage = data.message
  //       this.openSnackbar(snackMessage);
  //       return;
  //     }
  //     this.customer_name = data.data.customer.name;
  //     this.customer_add = data.data.customer.address;
  //     this.project_type = data.data.customer.project_types;
  //     this.stage_type = data.data.stage.name;
  //     this.date_created = data.data.stage.date_created;
  //     this.org = data.data.franchisee.org_name;
  //     this.areaOfHouseArrayInScope = data?.data?.items.filter(el => el.data.filter(el => el.outScope === false).length !== 0).map(el => {
  //       return {
  //         area_of_house: el.area_of_house,
  //         data: el.data.filter(el => el.outScope === false)
  //       }
  //     });
  //     this.areaOfHouseArrayOutScope = data?.data?.items.filter(el => el.data.filter(el => el.outScope === true).length !== 0).map(el => {
  //       return {
  //         area_of_house: el.area_of_house,
  //         data: el.data.filter(el => el.outScope === true)
  //       }
  //     });
  //     // console.log(this.areaOfHouseArrayInScope);
  //     // console.log(this.areaOfHouseArrayOutScope);


  //   });
  //   // Call api for Contractor Type
  //   this.generatePdfService.generatePDF({ ...commonPayload, "group_type": "CT", }).subscribe((data) => {
  //     // this.tradeTypeArrayInScope = data?.data?.items
  //     this.tradeTypeArrayInScope = data?.data?.items.filter(el => el.data.filter(el => el.outScope === false).length !== 0).map(el => {
  //       return {
  //         trade_type: el.trade_type,
  //         data: el.data.filter(el => el.outScope === false)
  //       }
  //     });
  //     this.tradeTypeArrayOutScope = data?.data?.items.filter(el => el.data.filter(el => el.outScope === true).length !== 0).map(el => {
  //       return {
  //         trade_type: el.trade_type,
  //         data: el.data.filter(el => el.outScope === true)
  //       }
  //     });
  //     // console.log(this.tradeTypeArrayInScope);
  //     // console.log(this.tradeTypeArrayOutScope);
  //   })
  // }
  getDailyLogsOnID() {
    // Do not load if already loading
    if (this.loadingSubject.value) {
      return;
    }

    // We are currently loading values
    this.loadingSubject.next(true);
    console.log(this.dailyLogId);
    let request = {
      'daily_log_id': this.dailyLogId,
      'type': this.type,
    }
    this.dailyLogsService.getDailyLogsOnId(request).pipe(takeUntil(this.ngUnsubscribe),
      finalize(() => this.loadingSubject.next(false))).subscribe(data => {
        console.log(data?.data);
        console.log(data?.data?.weatherDetails);
        console.log(data?.data?.weatherDetails[0]);
        console.log(data?.data?.weatherDetails[0]?.temp);
        this.photos = data?.photoes;
        this.documents = data?.documents;
        this.videos = data?.videos;
        this.projectName = data?.data.project_name;
        this.titleName = data?.data.log_title;
        this.titleDescription = data?.data.log_description;
        this.created_by=data?.data?.created_name;
        this.temperature = data?.data?.weatherDetails[0]?.temp
        this.location = data?.data?.weatherDetails[0]?.location
        this.icon=data?.data?.weatherDetails[0]?.icon;
        if(data?.data?.weatherDetails?.length>0) this.icon_url = `http://openweathermap.org/img/wn/${data?.data?.weatherDetails[0]?.icon}@2x.png `
        else this.icon_url='';
        this.humidity = data?.data?.weatherDetails[0]?.weather_details?.humidity
        this.wind_speed = data?.data?.weatherDetails[0]?.weather_details?.wind_speed
        this.feel_like_temp = data?.data?.weatherDetails[0]?.weather_details?.feel_like_temp
        this.weather_desc = data?.data?.weatherDetails[0]?.weather_details?.weather_desc
        this.weather_desc=this.weather_desc?.charAt(0)?.toUpperCase() + this.weather_desc?.slice(1)?.toLowerCase()
        this.weatherDetails=data?.data?.weatherDetails;
        console.log(data);
        console.log(this.icon_url);
      })
  }

  downloadFile(file) {
    if (file?.file_path && file?.file_path !== '') {
      window.open(file.file_path, '_blank');
    }
  }

  public async convertToPDF() {
    this.isDownloadingPdf=true;
    let data_to_pdf={
      photos:this.photos.map(photo=>`${photo?.file_path}?v=${new Date().getTime()}`),
      titleName:this.titleName,
      created_by:this.created_by,
      titleDescription:this.titleDescription,
      temperature:this.temperature,
      location:this.location,
      icon:this.icon,
      icon_url:this.icon_url,
      humidity:this.humidity,
      wind_speed:this.wind_speed,
      logo:this.logo,
      weather_desc:this.weather_desc,
      printed_on:new Date().toLocaleDateString(),
      weather_details:this.weatherDetails
    }
    this.generatePdf(data_to_pdf);
    // variables as  example
    // const elementToConvert = this.contentToConvert.nativeElement;
    // // let imageElement=elementToConvert.getElementsByTagName('img');
    // let imageElement = elementToConvert.querySelector('.icon_img');
    // let imagesUrls = [
    //   "http://controlfms-costing-uploads-dev.s3.ap-southeast-2.amazonaws.com/1722916446766_sample_640%C3%83%C2%97426%20%282%29.jpg",
    //   // "https://img-19.commentcamarche.net/cI8qqj-finfDcmx6jMK6Vr-krEw=/1500x/smart/b829396acc244fd484c5ddcdcb2b08f3/ccmcms-commentcamarche/20494859.jpg",
    //   // "https://img-19.commentcamarche.net/cI8qqj-finfDcmx6jMK6Vr-krEw=/1500x/smart/b829396acc244fd484c5ddcdcb2b08f3/ccmcms-commentcamarche/20494859.jpg",
    // ];
    // // Array.from(imageElement)?.map((img:HTMLImageElement)=>{
    // //     imagesUrls.push(img?.src)
    // //     console.log(img?.src);
    // // })
    // let img = imageElement as HTMLImageElement;
    // imagesUrls.push(imageElement?.src)
    // // for (let imgTag of Array.from(imageElement)) {
    // //   let img = imgTag as HTMLImageElement
    // //   imagesUrls.push(img?.src)
    // //   console.log(imgTag);
    // //   console.log(img);
    // // }
    // console.log(imagesUrls);
    // let content = "";
    // content += "<h1> Test of html2pdf </h1>";
    // const toDataUrl = async function (url) {
    //   //Convert to base64
    //   return new Promise((resolve, reject) => {
    //     var xhr = new XMLHttpRequest();
    //     xhr.onload = function () {
    //       var reader = new FileReader();
    //       reader.onloadend = function () {
    //         resolve(reader.result);
    //       };
    //       reader.readAsDataURL(xhr.response);
    //     };
    //     xhr.onerror = () => {
    //       reject({
    //         status: this.status,
    //         statusText: xhr.statusText,
    //       });
    //     };
    //     xhr.open("GET", url);
    //     xhr.responseType = "blob";
    //     xhr.send();
    //   });
    // };
    // //Converting to base 64 and adding to content
    // for (let url of imagesUrls) {
    //   let urlBase64 = await toDataUrl(url);
    //   content += '<img src="' + urlBase64 + '" width="600" ><br>';
    // }
    // content += "<h3> End of test </h3>";
    // // elementToConvert.insertAdjacentHTML('')
    // // elementToConvert.
    // // document.body.app
    // // elementToConvert.querySelector('.icon_img').appendchild(content)
    // // document.querySelector('.icon_img').remove();
    
    // // html2pdf(content, {
    // //   margin: 1,
    // //   filename: "document.pdf",
    // //   image: { type: "jpeg", quality: 0.98 },
    // //   html2canvas: { dpi: 192, letterRendering: true },
    // //   jsPDF: { unit: "in", format: "letter", orientation: "landscape" },
    // // });
    // // if (!this.contentToConvert || !this.contentToConvert.nativeElement) {
    // //   // console.error("contentToConvert not found or is undefined.");
    // //   return;
    // // }

    // // const elementToConvert = this.contentToConvert.nativeElement;
    // // console.log("data from", elementToConvert);


    // const options = {
    //   filename: 'daily-log.pdf',
    //   html2canvas: { scale: 2 },
    //   jsPDF: { format: 'a4', orientation: 'portrait', },
    //   pagebreak: { mode: 'avoid-all', before: '#page2el', after: ['#page3el', '#page4el'], }
    // };

    // html2pdf().set(options).from(elementToConvert).toPdf().get('pdf').then(pdf => {
    //   const pdfBuffer = pdf.output('arraybuffer');
    //   // Now you have the PDF buffer, you can use it as needed
    //   const blob = new Blob([pdfBuffer], { type: 'application/pdf' });

    //   // Create object URL for the Blob
    //   const blobUrl = URL.createObjectURL(blob);

    //   // Open Blob URL in a new tab
    //   window.open(blobUrl, '_blank');
    // });
  }
  back(){
    console.log({
      daily_log_id:this.dailyLogId,
      type:this.type,
      project_id:this.project_id,
      user_id:this.user_id
    });
    this.router.navigate(['/project/daily-logs/single-daily-log'],{queryParams:{
      daily_log_id:this.dailyLogId,
      type:this.type,
      project_id:this.project_id,
      user_id:this.user_id
    }})
  }
  
  // PDF Code 
  async generatePdf(data) {
    console.log(data?.photos);
    const documentDefinition = await this.getDocumentDefinition(data);
    pdfMake.createPdf(documentDefinition).download();
    this.isDownloadingPdf=false;
}

async getDocumentDefinition(data) {
    // let photosHttp = data?.photos?.map(photo => photo.replace(/^https:/, 'http:'));
    const imageBase64logo = `${await this.getBase64ImageFromUrl(data?.logo)}?v=${new Date().getTime()}`;
    let attchUrls = [];
    for (let photo of data?.photos) {
        attchUrls.push(`${await this.getBase64ImageFromUrl(photo)}?v=${new Date().getTime()}`)
    }
    console.log(attchUrls);
    let arr1 = [];
    let arr2 = [];
    let arr3 = [];
    let arr4 = [];
    // attchUrls.map((el, i) => 

        for(let i=0;i<=attchUrls?.length;i++){ 
            if(i<3 && attchUrls[i]) arr1.push(attchUrls[i])
                if(i>2 && i<6 && attchUrls[i]) arr2.push(attchUrls[i])
                if(i>5 && i<9 && attchUrls[i]) arr3.push(attchUrls[i])
                if(i>8 && i<12 && attchUrls[i]) arr4.push(attchUrls[i])
        }
    //array 1
    if(arr1?.length==0){
        arr1?.push(null)
        arr1?.push(null)
        arr1?.push(null)
    }
    if(arr1?.length==1){
        arr1?.push(null)
        arr1?.push(null)
    }
    if(arr1?.length==2){
        arr1?.push(null)
    }
    //array 2
    if(arr2?.length==0){
        arr2?.push(null)
        arr2?.push(null)
        arr2?.push(null)
    }
    if(arr2?.length==1){
        arr2?.push(null)
        arr2?.push(null)
    }
    if(arr2?.length==2){
        arr2?.push(null)
    }
    //array 3
    if(arr3?.length==0){
        arr3?.push(null)
        arr3?.push(null)
        arr3?.push(null)
    }
    if(arr3?.length==1){
        arr3?.push(null)
        arr3?.push(null)
    }
    if(arr3?.length==2){
        arr3?.push(null)
    }
    //array 4
    if(arr4?.length==0){
        arr4?.push(null)
        arr4?.push(null)
        arr4?.push(null)
    }
    if(arr4?.length==1){
        arr4?.push(null)
        arr4?.push(null)
    }
    if(arr4?.length==2){
        arr4?.push(null)
    }


    console.log(arr1);
    console.log(arr2);
    console.log(arr3);
    console.log(arr4);
   let contentArr:any= [
        {
            image: imageBase64logo,
            width: 150,
            margin: [0, 0, 0, 20]
        },
        {
            columns: [
                {
                    text: [{
                        text: 'Log Title : ', bold: true
                    },
                    {
                        text: data?.titleName,
                    }], width: '*', style: 'font11'
                },
                {
                    text: [{
                        text: 'Created by : ', bold: true
                    },
                    {
                        text: data?.created_by,
                    }
                    ], width: '*', alignment: 'right', style: 'font10'
                }
            ]
        },
        {
            columns: [
                {
                    text: [{
                        text: data?.titleDescription ? 'Description : ' : '', bold: true, style: 'font11'
                    },
                    {
                        text: data?.titleDescription,
                    }], width: '*', style: 'font10'
                },
                {
                    text: [{
                        text: 'Printed On : ', bold: true
                    },
                    {
                        text: data?.printed_on,
                    }], width: '*', alignment: 'right', style: 'font10'
                }
            ]
        },
        
    ];
    if(data?.weather_details.length>0){
        contentArr[3]={
            columns: [
                {
                    table: {
                        body: [
                            [
                                {
                                    image: await this.getBase64ImageFromUrl(data?.icon_url),
                                    width: 50,
                                },
                                { margin: [0, 10, 0, 0], stack: [{ text: '30.16°C', style: 'font11', bold: true },
                                { text: '34.16°C', style: 'font10' }] },
                                {
                                    margin: [0, 20, 0, 0],
                                    table: {
                                        body: [
                                            [
                                                {
                                                    image: await this.getBase64ImageFromUrl('./../../../../assets/images/location.svg'),
                                                    width: 10
                                                },
                                                { text: data?.location, style: 'font9' },],
                                        ]
                                    }, layout: 'noBorders'
                                },
                                {
                                    margin: [0, 20, 0, 0],
                                    table: {
                                        body: [
                                            [{
                                                image: await this.getBase64ImageFromUrl('./../../../../assets/images/wind-speed.svg'),
                                                width: 10
                                            }, { text: data?.wind_speed, style: 'font9' },],
                                        ]
                                    }, layout: 'noBorders'
                                },
                                {
                                    margin: [0, 20, 0, 0],
                                    table: {
                                        body: [
                                            [
                                                {
                                                    image: await this.getBase64ImageFromUrl('./../../../../assets/images/humidity.svg'),
                                                    width: 10
                                                }, { text: data?.humidity, style: 'font9' },],
                                        ]
                                    }, layout: 'noBorders'
                                },
                            ],
                        ]
                    }, layout: 'noBorders', width: '50%'
                },

            ], margin: [0, 10, 0, 0]
        }};
    if(data?.weather_desc){
        contentArr[4]={
            text: [{
                text: 'Weather Description : ', bold: true
            },
            {
                text: data?.weather_desc,
            }], style: 'font10', margin: [0, 10, 0, 20]
        }
    }
    if(attchUrls?.length){
       contentArr.push({text:"Attachments",alignment:'center',fontSize:13,bold:true}) 
    }        
    
    if(arr1?.length>0){contentArr.push({
        columns:(arr1?.map((url) => {

            let obj={};
            if(url) obj={stack:[{
                margin: [10, 20, 0, 10],
                image: url,
                width: 140,
            }]}
            else obj={stack:[{
                margin: [10, 20, 0, 10],
                text:'',
                width: 140,
            }]};
            return obj
        })
        )
    })}
    if(arr2?.length>0){contentArr.push({
        columns:(arr2?.map((url) => {
             let obj={};
            if(url) obj={stack:[{
                margin: [10, 20, 0, 10],
                image: url,
                width: 140,
            }]}
            else obj={stack:[{
                margin: [10, 20, 0, 10],
                text:'',
                width: 140,
            }]};
            return obj
        })
        )
    })}
    if(arr3?.length>0){contentArr.push({
        columns:(arr3?.map((url) => {
             let obj={};
            if(url) obj={stack:[{
                margin: [10, 20, 0, 10],
                image: url,
                width: 140,
            }]}
            else obj={stack:[{
                margin: [10, 20, 0, 10],
                text:'',
                width: 140,
            }]};
            return obj
        })
        )
    })}
    if(arr4?.length>0){contentArr.push({
        columns:(arr4?.map((url) => {
             let obj={};
            if(url) obj={stack:[{
                margin: [10, 20, 0, 10],
                image: url,
                width: 140,
            }]}
            else obj={stack:[{
                margin: [10, 20, 0, 10],
                text:'',
                width: 140,
            }]};
            return obj
        })
        )
    })}
    console.log(contentArr);
    return {
        
        content:contentArr,
        styles: {
            font9: {
                fontSize: 9
            },
            font8: {
                fontSize: 8
            },
            font10: {
                fontSize: 10
            },
            font11: {
                fontSize: 11
            },
            font12: {
                fontSize: 12
            }
        }
    };
}

getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.src = url;
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            const dataURL = canvas.toDataURL('image/png');
            // console.log(dataURL);
            resolve(dataURL);
        };
        img.onerror = error => reject(error);
    });
}
}
